import ClassIIITolerance from './ClassIIITolerance'

export default ClassIIITolerance
